import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { config } from './config/env';
import { validateMapsConfig } from './config/maps';
import { initErrorReporting } from './utils/errorReporting';
import { initPerformanceMonitoring } from './utils/monitoring';
import { browserSupport } from './utils/browserSupport';

// Validate all configurations
try {
  config.validate();
  validateMapsConfig();
} catch (error) {
  console.error('Configuration error:', error);
}

// Initialize monitoring and error reporting
initErrorReporting();
initPerformanceMonitoring();

// Load polyfills and initialize app
browserSupport.loadPolyfills().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});